import React from 'react'
import BookApp from '../components/BookApp';

function Book() {
  return (
    <div className='py-20 mb-20'>
        <BookApp/>
    </div>
  )
}

export default Book;